import mailBoxService from '@/services/mailBox.service.js'

export default {
    async getMasterData({dispatch, commit}, params, type) {
        return await mailBoxService
            .getMasterData(params, type)
            .then((response) => {
                if (response.success && response.data) {
                    // dispatch("alertSuccess", response.message, { root: true });
                    return Promise.resolve(response.data)
                } else {
                    dispatch('alertError', response.message, {root: true})
                }
            })
            .catch((error) => {
                dispatch('alertError', error, {root: true})
                return Promise.reject(false)
            })
    }
}